import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ISecretPayload, ISecretResponse, ISecretForm } from '@mode/notebooks/contract';

@Injectable({ providedIn: 'root' })
export class NotebookSecretClientService {
  constructor(private http: HttpClient) {}

  public getSecrets(accountId: string, reportId: string, notebookId: string): Observable<ISecretResponse> {
    return this.http.get<ISecretResponse>(`/api/${accountId}/reports/${reportId}/notebooks/${notebookId}/secrets`);
  }

  public createSecret(
    accountId: string,
    reportId: string,
    notebookId: string,
    payload: ISecretPayload
  ): Observable<ISecretForm> {
    return this.http.post<ISecretForm>(
      `/api/${accountId}/reports/${reportId}/notebooks/${notebookId}/secrets`,
      payload
    );
  }

  public editSecret(
    accountId: string,
    reportId: string,
    notebookId: string,
    secretId: string,
    payload: ISecretPayload
  ): Observable<ISecretForm> {
    return this.http.put<ISecretForm>(
      `/api/${accountId}/reports/${reportId}/notebooks/${notebookId}/secrets/${secretId}`,
      payload
    );
  }

  public deleteSecret(
    accountId: string,
    reportId: string,
    notebookId: string,
    secretId: string,
    payload: {
      session_id?: string;
    }
  ): Observable<ISecretForm> {
    return this.http.delete<ISecretForm>(
      `/api/${accountId}/reports/${reportId}/notebooks/${notebookId}/secrets/${secretId}`,
      {
        body: payload,
      }
    );
  }
}
